import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  UploadResult,
  StorageReference,
} from "firebase/storage";
import { storage } from "./init";

/**
 * 上傳文件到 Firebase Storage
 */
export async function uploadFile(
  path: string,
  file: File
): Promise<string> {
  try {
    const storageRef = ref(storage, path);
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error(`Error uploading file to ${path}:`, error);
    throw error;
  }
}

/**
 * 獲取下載 URL
 */
export async function getFileDownloadURL(path: string): Promise<string> {
  try {
    const storageRef = ref(storage, path);
    return await getDownloadURL(storageRef);
  } catch (error: any) {
    // 檢查是否為文件不存在的錯誤
    const isNotFoundError = 
      error?.code === "storage/object-not-found" ||
      error?.message?.includes("does not exist") ||
      (error?.message?.includes("Object") && error?.message?.includes("not found"));
    
    // 如果文件不存在，不記錄錯誤（這是正常情況，某些文件可能不存在）
    if (!isNotFoundError) {
      console.error(`Error getting download URL for ${path}:`, error);
    }
    throw error;
  }
}

/**
 * 刪除文件
 */
export async function deleteFile(path: string): Promise<void> {
  try {
    const storageRef = ref(storage, path);
    await deleteObject(storageRef);
  } catch (error) {
    console.error(`Error deleting file ${path}:`, error);
    throw error;
  }
}



